import { useState, useRef, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
//import { initialProducts } from "../data/products";
import type { Brand, Category, Material, OccasionType, Product, ProductImage, StoneType } from "../data/types";
import { DataTable } from "../components/DataTable";
import type { DataTableColumn } from "../components/DataTable";
import { createProduct, deleteProduct, getBrands, getCategories, getMaterials, getOccasionType, getProducts, getStoneType, updateProduct } from "../services/productService";
// import
import Swal from "sweetalert2";

const ANGLE_OPTIONS = ["Front", "Back", "Side", "Close-up", "On Model", "Flat Lay", "Packaging", "Other"];
//const STATUS_OPTIONS: Product["status"][] = ["active", "inactive", "draft"];
//const CATEGORY_OPTIONS = ["Necklace", "Earrings", "Bangles", "Ring", "Bracelet", "Pendant", "Set", "Other"];
const WEIGHT_UNIT_OPTIONS = ["g", "kg", "oz", "ct"];
const GENDER_OPTIONS = ["Women", "Men", "Unisex", "Kids"];
//const STONE_TYPE_OPTIONS = ["No Stone", "Diamond", "Ruby", "Emerald", "Sapphire", "Pearl", "Kundan", "Polki", "Other"];
//const OCCASION_OPTIONS = ["Bridal", "Casual", "Party", "Festival", "Office", "Daily Wear", "Gift", "Other"];

const emptyProduct = (): Omit<Product, "productID"> => ({
  name: "", sku: "", categoryName: "", categoryID: 0, brand: "", brandID: 0, price: 0, mrp: 0, discount: 0,
  stockQty: 0, minStockQty: 0, weight: "", weightUnit: "g", materialName: "", MaterialID: 0, purity: "",
  stoneTypeID: 0, gender: "", occasionTypeID: 0, shortDescription: "",
  description: "", tags: [], status: "draft", images: [],
  featured: false, trending: false, bestSeller: false, newArrival: false,
  productSlug: "",
  metaTitle: "", metaDescription: "", metaKeywords: "", ogTitle: "", ogDescription: "", ogImage: "", canonicalUrl: "",
});

type ModalMode = "none" | "add" | "edit" | "view";

const STATUS_COLOR: Record<Product["status"], { bg: string; color: string }> = {
  active: { bg: "#dcfce7", color: "#166534" },
  inactive: { bg: "#fee2e2", color: "#991b1b" },
  draft: { bg: "#fef3c7", color: "#92400e" },
};


export function ProductsPage() {

  const { user } = useAuth();

  const canManage =
    user?.role?.toLowerCase() ===
    "admin";


  const [products, setProducts] = useState<Product[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [brands, setBrands] = useState<Brand[]>([]);
  const [materials, setMaterials] = useState<Material[]>([]);
   const [stoneType, setStoneType] = useState<StoneType[]>([]);
  const [occasionType, setOccasionType] = useState<OccasionType[]>([]);

  const [modalMode, setModalMode] = useState<ModalMode>("none");

  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [formData, setFormData] = useState<Omit<Product, "productID">>(emptyProduct());
  const [tagInput, setTagInput] = useState("");
  const [galleryActive, setGalleryActive] = useState(0);
  const [deleteConfirm, setDeleteConfirm] = useState<number | null>(null);
  const ogImageFileRef = useRef<HTMLInputElement>(null);
  const [ogImageFile, setOgImageFile] = useState<File | null>(null);


  useEffect(() => {
    loadProducts();
    loadCategories();
    loadBrands();
    loadMaterials();
    loadStoneType();
    loadOccasionType();
  }, []);

  async function loadProducts() {
    try {
      const data = await getProducts();
      setProducts(data.dataList);
    } catch (error) {
      console.error(error);
    }
  }


  async function loadCategories() {
    const res = await getCategories();
    setCategories(res.dataList);
  }

  async function loadBrands() {
    const res = await getBrands();
    setBrands(res.dataList);
  }
  async function loadMaterials() {
    const res = await getMaterials();
    setMaterials(res.dataList);
  }
  async function loadStoneType() {
    const res = await getStoneType();
    console.log("stone",res)
    setStoneType(res.dataList);
  }
  async function loadOccasionType() {
    const res = await getOccasionType();
    console.log("occ",res)
    setOccasionType(res.dataList);
  }



  async function saveProduct() {

    try {

      const fd = new FormData();

      // =========================
      // BASIC FIELDS
      // =========================

      fd.append("ProductName", formData.name);
      fd.append(
        "ProductSlug",
        formData.productSlug || ""
      );
      fd.append("SKU", formData.sku);
      fd.append(
        "CategoryID",
        String(formData.categoryID)
      );

      fd.append("BrandID", String(formData.brandID))

      fd.append(
        "Description",
        formData.description || ""
      );
      fd.append(
        "MaterialID",
        String(formData.MaterialID)
      );
      fd.append(
        "Weight",
        formData.weight || ""
      );

      fd.append("MRP", String(formData.mrp));

      fd.append("SellingPrice", String(formData.price));
      fd.append(
        "Discount",
        String(formData.discount)
      );

      fd.append("StockQty", String(formData.stockQty));

      fd.append(
        "MinStockQty",
        String(formData.minStockQty)
      );


      fd.append(
        "WeightUnit",
        formData.weightUnit || ""
      );



      fd.append(
        "Purity",
        formData.purity || ""
      );

      fd.append(
        "StoneType",
        String(formData.stoneTypeID) 
      );

      fd.append(
        "Gender",
        formData.gender || ""
      );

      fd.append(
        "OccasionType",
       String(formData.occasionTypeID)
      );

      fd.append(
        "ShortDescription",
        formData.shortDescription || ""
      );


      fd.append("Status", formData.status);

      fd.append(
        "IsFeatured",
        String(formData.featured)
      );

      fd.append(
        "IsTrending",
        String(formData.trending)
      );

      fd.append(
        "IsBestSeller",
        String(formData.bestSeller)
      );

      fd.append(
        "IsNewArrival",
        String(formData.newArrival)
      );



      fd.append(
        "MetaTitle",
        formData.metaTitle || ""
      );

      fd.append(
        "MetaDescription",
        formData.metaDescription || ""
      );

      fd.append(
        "MetaKeywords",
        formData.metaKeywords || ""
      );

      fd.append(
        "OgTitle",
        formData.ogTitle || ""
      );

      fd.append(
        "OgDescription",
        formData.ogDescription || ""
      );

      fd.append(
        "CanonicalUrl",
        formData.canonicalUrl || ""
      );

      fd.append(
        "IsFeatured",
        String(formData.featured)
      );

      fd.append(
        "IsTrending",
        String(formData.trending)
      );

      fd.append(
        "IsBestSeller",
        String(formData.bestSeller)
      );

      fd.append(
        "IsNewArrival",
        String(formData.newArrival)
      );
      // =========================
      // TAGS
      // =========================

      formData.tags.forEach(tag => {
        fd.append("Tags", tag);
      });

      // =========================
      // IMAGES
      // =========================

      formData.images.forEach((img, index) => {

        // uploaded file
        if (img.file) {
          fd.append(
            `Images[${index}].File`,
            img.file
          );
        }

        // metadata
        fd.append(
          `Images[${index}].ImageAngle`,
          img.angle
        );
        fd.append(
          `Images[${index}].IsPrimary`,
          String(img.isPrimary || false)
        );

        fd.append(
          `Images[${index}].DisplayOrder`,
          String(img.displayOrder || 0)
        );

        // external URL
        if (
          img.url &&
          img.url.startsWith("http")
        ) {
          fd.append(
            `Images[${index}].ImageURL`,
            img.url
          );
        }
      });

      // =========================
      // OG IMAGE
      // =========================

      if (ogImageFile) {

        fd.append(
          "OgImageFile",
          ogImageFile
        );
      }
      else if (
        formData.ogImage &&
        formData.ogImage.startsWith("http")
      ) {

        fd.append(
          "OgImage",
          formData.ogImage
        );
      }
      // =========================
      // SAVE
      // =========================

      if (modalMode === "add") {

        await createProduct(fd);
      }

      if (
        modalMode === "edit" &&
        selectedProduct
      ) {

        await updateProduct(
          selectedProduct.productID,
          fd
        );
      }

      await loadProducts();

      closeModal();

    } catch (error: any) {

      console.error(error);

      const message =
        error || error?.response?.data?.message ||
        "Something went wrong";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
        confirmButtonText: "OK"
      });
    }
  }

  async function doDelete() {

    if (deleteConfirm === null) return;

    // const result = await Swal.fire({
    //   title: "Delete Product?",
    //   text: "This action cannot be undone.",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonText: "Yes, Delete",
    //   cancelButtonText: "Cancel",
    //   reverseButtons: true,
    //   confirmButtonColor: "#dc3545",
    //   cancelButtonColor: "#6c757d",
    // });

    // if (!result.isConfirmed) return;

    try {

      await deleteProduct(deleteConfirm);

      setProducts(prev =>
        prev.filter(
          p => p.productID !== deleteConfirm
        )
      );

      setDeleteConfirm(null);

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Product deleted successfully.",
        timer: 3000,
        showConfirmButton: false,
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: "Something went wrong.",
      });
    }
  }
  function openAdd() { setFormData(emptyProduct()); setTagInput(""); setModalMode("add"); }
  function openEdit(p: Product) { setFormData({ ...p }); setTagInput(""); setSelectedProduct(p); setModalMode("edit"); }
  function openView(p: Product) { setSelectedProduct(p); setGalleryActive(0); setModalMode("view"); }
  function closeModal() { setModalMode("none"); setSelectedProduct(null); }

  function hf<K extends keyof typeof formData>(k: K, v: typeof formData[K]) {
    setFormData((prev) => {
      const u = { ...prev, [k]: v };
      if ((k === "mrp" || k === "price") && u.mrp > 0) u.discount = Math.round(((u.mrp - u.price) / u.mrp) * 100);
      return u;
    });
  }

  function addTag() {
    const t = tagInput.trim().toLowerCase();
    if (t && !formData.tags.includes(t)) hf("tags", [...formData.tags, t]);
    setTagInput("");
  }
  function removeTag(tag: string) { hf("tags", formData.tags.filter((t) => t !== tag)); }

  function addImage() {
    hf("images", [...formData.images, { id: `img-${Date.now()}`, url: "", angle: ANGLE_OPTIONS[0] }]);
  }
  function updateImage(
    id: string,
    field: keyof ProductImage,
    value: any
  ) {
    hf(
      "images",
      formData.images.map((img) =>
        img.id === id
          ? { ...img, [field]: value }
          : img
      )
    );
  }
  function removeImage(id: string) { hf("images", formData.images.filter((img) => img.id !== id)); }

  // ---- DataTable columns ----
  const columns: DataTableColumn<Record<string, unknown>>[] = [
    {
      key: "name", label: "Product", sortable: true,
      render: (row) => {
        const p = row as unknown as Product;
        return (
          <div className="d-flex align-items-center gap-2">
            <div className="prdt-thumb-wrap">
              {p.images[0]?.url ? <img src={p.images[0].url} alt={p.name} /> : "💍"}
            </div>
            <div>
              <div className="prdt-name">{p.name}</div>
              <div className="prdt-brand">{p.brand}</div>
            </div>
          </div>
        );
      },
    },
    {
      key: "sku", label: "SKU", sortable: true,
      render: (row) => <code className="prdt-sku">{String(row.sku)}</code>
    },
    {
      key: "category", label: "Category", sortable: true,
      render: (row) => {
        return String(row.categoryName ?? "");
      },
    },
    {
      key: "mrp", label: "MRP", sortable: true,
      render: (row) => <span className="prdt-mrp">₹{Number(row.mrp).toLocaleString()}</span>
    },
    {
      key: "price", label: "Price", sortable: true,
      render: (row) => <span className="prdt-price">₹{Number(row.sellingPrice).toLocaleString()}</span>
    },
    {
      key: "discount", label: "Disc.", sortable: true,
      render: (row) => <span className="prdt-disc">{Number(row.discountPercent)}%</span>
    },
    {
      key: "stock", label: "Stock", sortable: true,
      render: (row) => {
        const s = Number(row.stockQty);
        return <span style={{ fontWeight: 600, color: s === 0 ? "#ef4444" : s < 10 ? "#f59e0b" : "var(--body-clr)" }}>{s}</span>;
      }
    },
    {
      key: "status", label: "Status", sortable: true,
      render: (row) => {

        const s =
          ((row.status as Product["status"]) ||
            "draft");

        return (
          <span
            className="pg-badge"
            style={{
              background:
                STATUS_COLOR[s]?.bg ||
                STATUS_COLOR.draft.bg,

              color:
                STATUS_COLOR[s]?.color ||
                STATUS_COLOR.draft.color
            }}
          >
            {s}
          </span>
        );
      }
    },
    ...(canManage ? [{
      key: "actions" as const, label: "Actions", className: "text-end",
      render: (row: Record<string, unknown>) => {
        const p = row as unknown as Product;
        return (
          <div className="pg-actions">
            <button type="button" onClick={() => openView(p)} title="View"
              className="pg-action-btn pg-action-edit">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
            </button>
            <button type="button" onClick={() => openEdit(p)} title="Edit"
              className="pg-action-btn pg-action-view">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
            </button>
            <button type="button" onClick={() => setDeleteConfirm(p.productID)} title="Delete"
              className="pg-action-btn pg-action-delete">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /></svg>
            </button>
          </div>
        );
      }
    }] : []),
  ];

  const stats = [
    { label: "Total Products", val: products.length, bg: "#f5f0eb", color: "var(--title)" },
    { label: "Active", val: products.filter(p => p.status === "active").length, bg: "#dcfce7", color: "#166534" },
    { label: "Draft", val: products.filter(p => p.status === "draft").length, bg: "#fef3c7", color: "#92400e" },
    { label: "Total Stock", val: products.reduce((a, p) => a + p.stockQty, 0), bg: "#e0e7ff", color: "#3730a3" },
  ];

  return (
    <>


      <div className="d-grid gap-4">
        {/* Stats */}
        <div className="pg-stats-grid">
          {stats.map((s, index) => (
            <div key={index} className="pg-stat-card" style={{ background: s.bg }}>
              <div className="pg-stat-label" style={{ color: s.color }}>{s.label}</div>
              <div className="pg-stat-value" style={{ color: s.color }}>{s.val}</div>
            </div>
          ))}
        </div>

        <DataTable
          title="Products"
          rows={products as unknown as Record<string, unknown>[]}
          columns={columns}
          rowKey={(row) => String(row.productID)}
          searchPlaceholder="Search by name, SKU, category, brand..."
          exportFileName="products"
          pageSize={8}
          headerAction={
            canManage ? (
              <button type="button" className="pm-btn-save" onClick={openAdd} >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                Add Product
              </button>
            ) : undefined
          }
        />
      </div>

      {/* ===== ADD / EDIT MODAL ===== */}
      {(modalMode === "add" || modalMode === "edit") && (
        <div className="pm-overlay" onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}>
          <div className="pm-modal">
            <div className="pm-head">
              <span className="pm-title">
                {modalMode === "add" ? <>➕ Add New Product</> : <>✏️ Edit Product</>}
              </span>
              <button className="pm-close" onClick={closeModal} type="button">✕</button>
            </div>

            <div className="pm-body">
              {/* Basic Info */}
              <div className="pm-section">📦 Basic Information</div>
              <div className="pm-grid">
                <div className="pm-field pm-full">
                  <label className="pm-label">Product Name <span className="pm-req">*</span></label>
                  <input className="pm-input" placeholder="e.g. Polki Bridal Necklace" value={formData.name} onChange={e => {
                    const v = e.target.value;
                    hf("name", v);
                    hf("productSlug", v.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, ""));
                  }} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Product Slug</label>
                  <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
                    <span style={{ padding: "8px 10px", background: "#f5ede3", border: "1.5px solid #ede6df", borderRight: "none", borderRadius: "10px 0 0 10px", fontSize: 12, color: "var(--smoke)", whiteSpace: "nowrap" }}>/product/</span>
                    <input className="pm-input" style={{ borderRadius: "0 10px 10px 0" }} placeholder="auto-generated" value={formData.productSlug} onChange={e => hf("productSlug", e.target.value)} />
                  </div>
                </div>
                <div className="pm-field">
                  <label className="pm-label">SKU <span className="pm-req">*</span></label>
                  <input className="pm-input" placeholder="e.g. NSJ-NK-001" value={formData.sku} onChange={e => hf("sku", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Brand</label>
                  {/* <input className="pm-input" placeholder="e.g. NineSisters" value={formData.brandID} onChange={e => hf("brand", e.target.value)} /> */}
                  <select
                    className="pm-select"
                    value={formData.brandID || ""}
                    onChange={e =>
                      hf("brandID", Number(e.target.value))
                    }
                  >
                    <option value="">
                      Select Brand...
                    </option>

                    {brands.map((c: any) => (
                      <option
                        key={c.brandID}
                        value={c.brandID}
                      >
                        {c.brandName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="pm-field">
                  <label className="pm-label">Category <span className="pm-req">*</span></label>
                  <select
                    className="pm-select"
                    value={formData.categoryID || ""}
                    onChange={e =>
                      hf("categoryID", Number(e.target.value))
                    }
                  >
                    <option value="">
                      Select category...
                    </option>

                    {categories.map((c: any) => (
                      <option
                        key={c.categoryID}
                        value={c.categoryID}
                      >
                        {c.categoryName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="pm-field">
                  <label className="pm-label">Status</label>
                  <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                    {(["draft", "active", "inactive"] as Product["status"][]).map((s) => {
                      const config = {
                        draft: { icon: "✏️", color: "#92400e", bg: "#fef3c7", border: "#f59e0b" },
                        active: { icon: "✅", color: "#166534", bg: "#dcfce7", border: "#22c55e" },
                        inactive: { icon: "🚫", color: "#991b1b", bg: "#fee2e2", border: "#ef4444" },
                      }[s];
                      const isSelected = formData.status === s;
                      return (
                        <button
                          key={s}
                          type="button"
                          onClick={() => hf("status", s)}
                          style={{
                            flex: 1,
                            padding: "8px 10px",
                            borderRadius: 10,
                            border: isSelected
                              ? `2px solid ${config.border}`
                              : "1.5px solid #ede6df",
                            background: isSelected ? config.bg : "transparent",
                            color: isSelected ? config.color : "var(--smoke)",
                            fontWeight: isSelected ? 600 : 400,
                            fontSize: 13,
                            cursor: "pointer",
                            transition: "all 0.15s",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <span style={{ fontSize: 16 }}>{config.icon}</span>
                          <span>{s.charAt(0).toUpperCase() + s.slice(1)}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div className="pm-field pm-full">
                  <label className="pm-label">Short Description</label>
                  <input className="pm-input" placeholder="Brief summary for listing pages..." value={formData.shortDescription} onChange={e => hf("shortDescription", e.target.value)} />
                </div>
                <div className="pm-field pm-full">
                  <label className="pm-label">Description</label>
                  <textarea className="pm-textarea" placeholder="Describe the product..." value={formData.description} onChange={e => hf("description", e.target.value)} />
                </div>
              </div>

              {/* Pricing */}
              <div className="pm-section">💰 Pricing & Stock</div>
              <div className="pm-grid g3">
                <div className="pm-field">
                  <label className="pm-label">MRP (₹)</label>
                  <input className="pm-input" type="number" placeholder="0" value={formData.mrp || ""} onChange={e => hf("mrp", Number(e.target.value))} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Selling Price (₹)</label>
                  <input className="pm-input" type="number" placeholder="0" value={formData.price || ""} onChange={e => hf("price", Number(e.target.value))} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Discount (%)</label>
                  <input className="pm-input pm-input-ro" type="number" readOnly value={formData.discount || ""} placeholder="Auto" />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Stock Qty</label>
                  <input className="pm-input" type="number" placeholder="0" value={formData.stockQty || ""} onChange={e => hf("stockQty", Number(e.target.value))} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Min Stock Qty <span className="pm-seo-opt">(alert threshold)</span></label>
                  <input className="pm-input" type="number" placeholder="0" value={formData.minStockQty || ""} onChange={e => hf("minStockQty", Number(e.target.value))} />
                </div>
              </div>

              {/* Details */}
              <div className="pm-section">📋 Product Details</div>
              <div className="pm-grid">
                <div className="pm-field">
                  <label className="pm-label">Material</label>
                  {/* <input className="pm-input" placeholder="e.g. 22K Gold, Kundan" value={formData.material} onChange={e => hf("material", e.target.value)} /> */}
                  <select
                    className="pm-select"
                    value={formData.MaterialID || ""}
                    onChange={e =>
                      hf("MaterialID", Number(e.target.value))
                    }
                  >
                    <option value="">
                      Select material...
                    </option>

                    {materials.map((c: any) => (
                      <option
                        key={c.materialID}
                        value={c.materialID}
                      >
                        {c.materialName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="pm-field">
                  <label className="pm-label">Purity</label>
                  <input className="pm-input" placeholder="e.g. 22K, 925 Silver" value={formData.purity} onChange={e => hf("purity", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Weight</label>
                  <input className="pm-input" placeholder="e.g. 85" value={formData.weight} onChange={e => hf("weight", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Weight Unit</label>
                  <select className="pm-select" value={formData.weightUnit} onChange={e => hf("weightUnit", e.target.value)}>
                    {WEIGHT_UNIT_OPTIONS.map(u => <option key={u} value={u}>{u}</option>)}
                  </select>
                </div>
                <div className="pm-field">
                  <label className="pm-label">Stone Type</label>
                  <select className="pm-select" value={formData.stoneTypeID} onChange={e => hf("stoneTypeID", Number(e.target.value))}>
                    <option value="">Select...</option>
                    {stoneType.map(s => <option key={s.stoneTypeID} value={s.stoneTypeID}>{s.stoneTypeName}</option>)}
                  </select>
                </div>
                <div className="pm-field">
                  <label className="pm-label">Gender</label>
                  <select className="pm-select" value={formData.gender} onChange={e => hf("gender", e.target.value)}>
                    <option value="">Select...</option>
                    {GENDER_OPTIONS.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
                <div className="pm-field pm-full">
                  <label className="pm-label">Occasion Type</label>
                  <select className="pm-select" value={formData.occasionTypeID} onChange={e => hf("occasionTypeID", Number(e.target.value))}>
                    <option value="">Select...</option>
                    {occasionType.map(o => <option key={o.occasionTypeID} value={o.occasionTypeID}>{o.occasionTypeName}</option>)}
                  </select>
                </div>
              </div>

              {/* Product Tags */}
              <div className="pm-section">
                🏷️ Product Tags
              </div>

              <div className="pm-product-badges">

                <label
                  className={`pm-badge-toggle${formData.featured ? " active" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={!!formData.featured}
                    onChange={e =>
                      hf("featured", e.target.checked)
                    }
                    style={{ display: "none" }}
                  />
                  ⭐ Featured
                </label>

                <label
                  className={`pm-badge-toggle${formData.trending ? " active" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={!!formData.trending}
                    onChange={e =>
                      hf("trending", e.target.checked)
                    }
                    style={{ display: "none" }}
                  />
                  🔥 Trending
                </label>

                <label
                  className={`pm-badge-toggle${formData.bestSeller ? " active" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={!!formData.bestSeller}
                    onChange={e =>
                      hf("bestSeller", e.target.checked)
                    }
                    style={{ display: "none" }}
                  />
                  🏆 Best Seller
                </label>

                <label
                  className={`pm-badge-toggle${formData.newArrival ? " active" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={!!formData.newArrival}
                    onChange={e =>
                      hf("newArrival", e.target.checked)
                    }
                    style={{ display: "none" }}
                  />
                  ✨ New Arrival
                </label>

              </div>

              {/* Custom Tags */}
              <div className="pm-section">🔖 Custom Tags</div>
              <div className="pm-tags-box">
                {formData.tags.map(tag => (
                  <span key={tag} className="pm-tag">{tag}<button className="pm-tag-x" onClick={() => removeTag(tag)} type="button">×</button></span>
                ))}
              </div>
              <div className="pm-tag-row">
                <input className="pm-tag-input" placeholder="Type a tag and press Enter or Add..." value={tagInput} onChange={e => setTagInput(e.target.value)} onKeyDown={e => e.key === "Enter" && addTag()} />
                <button className="pm-btn-cancel" onClick={addTag} type="button">Add</button>
              </div>

              {/* Gallery */}
              <div className="pm-section">🖼️ Product Gallery</div>
              {formData.images.map((img) => (
                <div key={img.id} className="pm-img-row">
                  <div style={{ display: "flex", flexDirection: "column", gap: 4, flex: 1 }}>
                    <input className="pm-input" placeholder="Paste image URL (https://...) or upload below" value={img.url} onChange={e => updateImage(img.id, "url", e.target.value)} />
                  <label className="pm-upload-label">
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={ev => {
                          const file = ev.target.files?.[0];

                          if (!file) return;

                          const preview =
                            URL.createObjectURL(file);

                          hf(
                            "images",
                            formData.images.map((x) =>
                              x.id === img.id
                                ? {
                                  ...x,
                                  file,
                                  url: preview
                                }
                                : x
                            )
                          );
                        }}
                      />
                   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
  <polyline points="17 8 12 3 7 8"/>
  <line x1="12" y1="3" x2="12" y2="15"/>
</svg>
Upload file
                    </label>
                  </div>
                  {img.url && <img src={img.url} alt={img.angle} style={{ width: 44, height: 44, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />}
                  <select className="pm-select" value={img.angle} onChange={e => updateImage(img.id, "angle", e.target.value)}>
                    {ANGLE_OPTIONS.map(a => <option key={a} value={a}>{a}</option>)}
                  </select>
                  <div
                    className="d-flex gap-3 align-items-start"
                    style={{ flexDirection: "column", minWidth: 140 }}
                  >
                    {/* PRIMARY IMAGE */}
                    <label
                      className={`pm-primary-toggle ${img.isPrimary ? "active" : ""
                        }`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        cursor: "pointer",
                        fontWeight: 600,
                        color: img.isPrimary ? "#166534" : "#555",
                        background: img.isPrimary
                          ? "#dcfce7"
                          : "#f5f5f5",
                        padding: "6px 10px",
                        borderRadius: 8,
                        border: img.isPrimary
                          ? "1px solid #22c55e"
                          : "1px solid #ddd",
                        width: "fit-content"
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={img.isPrimary || false}
                        onChange={(e) => {
                          hf(
                            "images",
                            formData.images.map((x) => ({
                              ...x,
                              isPrimary:
                                x.id === img.id
                                  ? e.target.checked
                                  : false
                            }))
                          );
                        }}
                      />

                      {img.isPrimary
                        ? "⭐ Primary Image"
                        : "Set Primary"}
                    </label>

                    {/* DISPLAY ORDER */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4
                      }}
                    >
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#666"
                        }}
                      >
                        Display Order
                      </label>

                      <input
                        type="number"
                        className="pm-input"
                        style={{ width: 110 }}
                        placeholder="0"
                        value={img.displayOrder || 0}
                        onChange={(e) =>
                          updateImage(
                            img.id,
                            "displayOrder" as any,
                            Number(e.target.value)
                          )
                        }
                      />
                    </div>
                  </div>
                  <button className="pm-img-del" onClick={() => removeImage(img.id)} type="button">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  </button>
                </div>
              ))}
              <button className="pm-img-add" onClick={addImage} type="button">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>
                Add Image
              </button>


              {/* SEO */}
              <div className="pm-section">🔍 SEO & Meta</div>
              <div className="pm-seo-hint">
                <i className="bi bi-info-circle me-1"></i>
                Configure how this product appears in Google search results and social media previews.
              </div>
              <div className="pm-grid">
                <div className="pm-field pm-full">
                  <label className="pm-label">
                    Meta Title
                    <span className="pm-seo-counter">{formData.metaTitle.length}/60</span>
                  </label>
                  <input className="pm-input" placeholder="e.g. Polki Bridal Necklace | NineSisters Jewels" maxLength={60}
                    value={formData.metaTitle} onChange={e => hf("metaTitle", e.target.value)} />
                </div>
                <div className="pm-field pm-full">
                  <label className="pm-label">
                    Meta Description
                    <span className="pm-seo-counter">{formData.metaDescription.length}/160</span>
                  </label>
                  <textarea className="pm-textarea pm-seo-meta-desc" placeholder="Concise summary shown in search results — 120–160 characters recommended" maxLength={160}
                    value={formData.metaDescription} onChange={e => hf("metaDescription", e.target.value)} />
                </div>
                <div className="pm-field pm-full">
                  <label className="pm-label">Meta Keywords <span className="pm-seo-opt">(optional)</span></label>
                  <input className="pm-input" placeholder="e.g. polki necklace, bridal jewellery, gold necklace"
                    value={formData.metaKeywords} onChange={e => hf("metaKeywords", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">Canonical URL <span className="pm-seo-opt">(optional)</span></label>
                  <input className="pm-input" placeholder="https://ninesistersjewels.com/product/..."
                    value={formData.canonicalUrl} onChange={e => hf("canonicalUrl", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">OG Title <span className="pm-seo-opt">(Social share title)</span></label>
                  <input className="pm-input" placeholder="e.g. Polki Bridal Necklace | NineSisters" value={formData.ogTitle} onChange={e => hf("ogTitle", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">OG Description <span className="pm-seo-opt">(Social share description)</span></label>
                  <input className="pm-input" placeholder="Social media preview description" value={formData.ogDescription} onChange={e => hf("ogDescription", e.target.value)} />
                </div>
                <div className="pm-field">
                  <label className="pm-label">OG Image <span className="pm-seo-opt">(Social share image)</span></label>
                  <div>
                    {formData.ogImage && (
                      <div style={{ position: "relative", display: "inline-block", marginBottom: 6 }}>
                        <img src={formData.ogImage} alt="OG preview"
                          style={{ height: 52, borderRadius: 8, objectFit: "cover", border: "1px solid #e8e0d8" }} />
                        <button type="button" style={{ position: "absolute", top: -6, right: -6, background: "#ef4444", border: "none", borderRadius: "50%", width: 18, height: 18, color: "#fff", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                          onClick={() => { hf("ogImage", ""); if (ogImageFileRef.current) ogImageFileRef.current.value = ""; }}>×</button>
                      </div>
                    )}
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 4 }}>
                      <button type="button" className="pm-btn-cancel"
                        onClick={() => ogImageFileRef.current?.click()}>
                        ↑ Upload
                      </button>
                      <input
                        ref={ogImageFileRef}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={e => {

                          const file =
                            e.target.files?.[0];

                          if (!file) return;

                          setOgImageFile(file);

                          hf(
                            "ogImage",
                            URL.createObjectURL(file)
                          );
                        }}
                      />
                      <input className="pm-input" style={{ flex: 1, minWidth: 120 }} placeholder="or paste URL: https://..."
                        value={formData.ogImage.startsWith("data:") ? "" : formData.ogImage}
                        onChange={e => hf("ogImage", e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pm-foot">
              <button className="pm-btn-cancel" onClick={closeModal} type="button">Cancel</button>
              <button className="pm-btn-save" onClick={saveProduct} type="button">
                {modalMode === "add" ? "Create Product" : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== VIEW MODAL ===== */}
      {modalMode === "view" && selectedProduct && (
        <div className="pm-overlay" onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}>
          <div className="pm-modal">
            <div className="pm-head">
              <span className="pm-title">🔍 {selectedProduct.name}</span>
              <div className="d-flex gap-2 align-items-center">
                {canManage && <button className="pm-btn-edit-sm" onClick={() => openEdit(selectedProduct)} type="button">✏️ Edit</button>}
                <button className="pm-close" onClick={closeModal} type="button">✕</button>
              </div>
            </div>
            <div className="pm-body">
              {selectedProduct.images.length > 0 && (
                <div className="pm-view-gallery">
                  <div>
                    <div className="pm-gallery-main">
                      {selectedProduct.images[galleryActive]?.url
                        ? <img src={selectedProduct.images[galleryActive].url} alt={selectedProduct.images[galleryActive].angle} />
                        : "💍"}
                    </div>
                    <div className="pm-angle-label mt-1">{selectedProduct.images[galleryActive]?.angle}</div>
                  </div>
                  <div className="pm-gallery-thumbs">
                    {selectedProduct.images.map((img, idx) => (
                      <div key={img.id}>
                        <button className={`pm-thumb-btn${idx === galleryActive ? " act" : ""}`} onClick={() => setGalleryActive(idx)} type="button">
                          {img.url ? <img src={img.url} alt={img.angle} /> : <div className="d-flex align-items-center justify-content-center h-100 fs-5">💍</div>}
                        </button>
                        <div className="pm-angle-label">{img.angle}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className="pm-view-grid">
                {[
                  { l: "SKU", v: <code className="prdt-detail-mono">{selectedProduct.sku}</code> },
                  { l: "Brand", v: selectedProduct.brand || "—" },
                  { l: "Category", v: selectedProduct.categoryID },
                  { l: "Status", v: <span className="pg-badge" style={{ background: STATUS_COLOR[selectedProduct.status].bg, color: STATUS_COLOR[selectedProduct.status].color }}>{selectedProduct.status}</span> },
                  { l: "MRP", v: <span className="prdt-detail-strike">₹{selectedProduct.mrp.toLocaleString()}</span> },
                  { l: "Price", v: <strong>₹{selectedProduct.price.toLocaleString()} <span className="prdt-detail-disc-clr">({selectedProduct.discount}% off)</span></strong> },
                  { l: "Stock", v: `${selectedProduct.stockQty} units` },
                  { l: "Weight", v: selectedProduct.weight || "—" },
                  { l: "Material", v: selectedProduct.materialName || "—", full: true },
                  { l: "Description", v: selectedProduct.description || "—", full: true },
                ].map((item, i) => (
                  <div key={i} className={`pm-view-item${item.full ? " pm-view-full" : ""}`}>
                    <div className="vl">{item.l}</div>
                    <div className="vv">{item.v}</div>
                  </div>
                ))}
                {selectedProduct.tags.length > 0 && (
                  <div className="pm-view-item pm-view-full">
                    <div className="vl">Tags</div>
                    <div className="d-flex flex-wrap gap-2 mt-1">
                      {selectedProduct.tags.map(t => <span key={t} className="prdt-view-tag">{t}</span>)}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== DELETE CONFIRM ===== */}
      {deleteConfirm && (
        <div className="pm-del-overlay" onClick={(e) => { if (e.target === e.currentTarget) setDeleteConfirm(null); }}>
          <div className="pm-del-box">
            <div className="pm-del-ico">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /></svg>
            </div>
            <div className="pm-del-title">Delete Product?</div>
            <div className="pm-del-sub">This action cannot be undone. The product will be permanently removed.</div>
            <div className="pm-del-btns">
              <button className="pm-btn-ghost" onClick={() => setDeleteConfirm(null)} type="button">Cancel</button>
              <button className="pm-btn-danger" onClick={doDelete} type="button">Delete</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
